import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const EdgeIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            className="icon-edge"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            strokeWidth="1.5"
            color="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                d="M5.63 1.755A11.687 11.687 0 0111.953.002C19.828.002 24 5.804 24 10.29a5.833 5.833 0 01-5.747 5.822c-3.525 0-4.289-1.083-4.289-1.5 0-.178.056-.291.225-.441l.047-.056.019-.075A2.865 2.865 0 0015 12.09C15 8.4 11.147 5.4 6.375 5.4a10.348 10.348 0 00-5.04 1.261c1.267-2.695 3.878-4.575 4.28-4.865.038-.028.015-.042.015-.042zm.73 14.91a9.236 9.236 0 00.77 4.087c.637 1.237 1.532 2.39 2.648 3.248-2.789-.539-5.226-2.058-7.003-4.186A12.15 12.15 0 010 12.09c0-2.4 2.925-4.425 6.375-4.425a7.8 7.8 0 014.772 1.533l-.169.056c-2.414.825-4.617 4.251-4.617 7.41zm15.662 2.085l-.033.005a10.586 10.586 0 01-1.978 2.32c-1.444 1.313-3.192 2.133-5.1 2.34a5.541 5.541 0 01-2.522-.535c-1.2-.483-2.208-1.406-2.887-2.484a6.312 6.312 0 01-.891-3.731c-.028-.943.253-1.89.703-2.728a8.364 8.364 0 007.922 5.128 9.415 9.415 0 004.228-.962l.09-.042c.182-.108.36-.183.543 0 .21.23.084.432-.056.657-.01.009-.014.023-.02.032z"
            ></path>
        </svg>
    </IconWrapper>
)
